var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.97,
    height: 27.543,
    viewBox: "0 0 39.97 27.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48231",
    "data-name": "Group 48231",
    transform: "translate(-3793.366 584.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42611",
    "data-name": "Path 42611",
    d: "M3824.758-583.631a1.325,1.325,0,0,0-1.874-.1,1.325,1.325,0,0,0-.1,1.873h0a17.185,17.185,0,0,1,4.417,11.55,17.207,17.207,0,0,1-4.419,11.563,1.326,1.326,0,0,0,.1,1.874,1.326,1.326,0,0,0,1.874-.1,19.873,19.873,0,0,0,5.1-13.338A19.831,19.831,0,0,0,3824.758-583.631Z",
    transform: "translate(3.478 0)",
    fill: "#00D8AE",
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42612",
    "data-name": "Path 42612",
    d: "M3800.44-558.739a17.274,17.274,0,0,1-4.42-11.566,17.244,17.244,0,0,1,4.419-11.552,1.327,1.327,0,0,0-.1-1.873,1.326,1.326,0,0,0-1.874.1,19.894,19.894,0,0,0-5.1,13.325,19.931,19.931,0,0,0,5.1,13.336,1.328,1.328,0,0,0,1.874.1,1.328,1.328,0,0,0,.1-1.874Z",
    transform: "translate(0 0)",
    fill: "#00D8AE",
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42613",
    "data-name": "Path 42613",
    d: "M3818.88-584.159a1.514,1.514,0,0,0-2.083.492,1.512,1.512,0,0,0,.493,2.083h0a11.649,11.649,0,0,1,5.536,9.919,11.641,11.641,0,0,1-5.544,9.929,1.512,1.512,0,0,0-.494,2.082,1.513,1.513,0,0,0,2.083.493,14.67,14.67,0,0,0,6.982-12.5A14.681,14.681,0,0,0,3818.88-584.159Z",
    transform: "translate(2.18 1.362)",
    fill: "#00D8AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42614",
    "data-name": "Path 42614",
    d: "M3805.222-561.737h0a11.64,11.64,0,0,1-5.544-9.929,11.65,11.65,0,0,1,5.537-9.919,1.512,1.512,0,0,0,.491-2.082,1.511,1.511,0,0,0-2.082-.491,14.674,14.674,0,0,0-6.972,12.492,14.669,14.669,0,0,0,6.983,12.5,1.514,1.514,0,0,0,2.082-.493A1.514,1.514,0,0,0,3805.222-561.737Z",
    transform: "translate(2.009 1.362)",
    fill: "#00D8AE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-9",
    transform: "translate(3804.04 -579.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42615",
    "data-name": "Path 42615",
    d: "M19.049,962.367A9.311,9.311,0,1,0,25.8,965,9.311,9.311,0,0,0,19.049,962.367Zm.262,4.656a4.609,4.609,0,0,1,3.288,1.309l1.368-1.309v3.724H20.242l1.338-1.4a3.229,3.229,0,0,0-2.24-.931,3.274,3.274,0,0,0-3.055,2.328H14.743a4.651,4.651,0,0,1,4.568-3.724Zm-4.656,5.587H18.38l-1.338,1.309a3.229,3.229,0,0,0,2.24.931,3.2,3.2,0,0,0,3.055-2.241h1.542a4.746,4.746,0,0,1-4.568,3.724,4.684,4.684,0,0,1-3.288-1.4l-1.368,1.4v-3.724Z",
    transform: "translate(-10 -962.363)",
    fill: "#00D8AE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveIcon);
export default __webpack_public_path__ + "static/media/live-icon.a289a39411fdfb88c77ec331feb62d1d.svg";
export { ForwardRef as ReactComponent };